/*
 * @Author: your name
 * @Date: 2020-07-07 15:13:38
 * @LastEditTime: 2020-09-07 15:44:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vip-center-2/src/pages/ProtocolAuto.js
 */
/* eslint-disable */
import React from 'react'
import SDK from '../sdk/utils'
import style from './ProtocolAutoStyle.module.scss'


export default props => {
  const isIos = SDK.isIos;
  console.log(isIos)
  return (
    <div className={style.privacy}>
    <h1>金山词霸隐私保护政策</h1>
    <h4>更新日期：2020年 3 月 14 日</h4>

    <br/>

    <p>感谢您选择使用由金山办公或其关联公司开发、运营的金山词霸软件（包括金山词霸软件的免费或收费版本、不同语言版本以及金山词霸软件的不同客户端（电脑端、WAP端、小程序、移动客户端（“APP”）及其他客户端））及金山办公或其关联公司及/或与金山办公及其关联公司存在合作关系的第三方合作伙伴已经或即将推出的使用金山词霸在线服务账号、第三方账号登录、使用的金山词霸在线服务！</p>

    <br/>

    <p>如果您对本隐私政策或个人信息保护有任何疑问、意见或建议，可通过以下方式与金山办公联系，金山办公会在十五个工作日内受理并处理：</p>
    <p>电子邮件：KCB_KF@kingsoft.com</p>
    <p>电话：4006775005</p>

    <br/>

    <h5><strong>特别提示</strong></h5>
    <p><strong>在您使用金山词霸软件、金山词霸在线服务前，请您务必仔细阅读本政策，金山办公将根据中华人民共和国（仅为本政策之目的，不包括香港、澳门特别行政区及台湾地区，以下称为“中国大陆”）相关法律法规的规定保护在您使用金山词霸软件、金山词霸在线服务的任何部分或全部的过程中金山办公收集的个人信息。本政策中与您的权益（可能）密切相关的重要条款，已采用加粗字体来特别提醒您，请您重点查阅。</strong></p>

    <br/>

    <h5>本政策将帮助您了解以下内容：</h5>
    <ul>
      <li>如何收集和使用您的个人信息</li>
      <li>如何使用Cookie和同类技术</li>
      <li>如何共享、转让、公开披露您的个人信息</li>
      <li>如何保护和保存您的个人信息</li>
      <li>查询、更正信息、撤回同意及删除账号的方式</li>
      <li>对未成年人信息的保护</li>
      <li>您的个人信息如何在全球范围转移</li>
      <li>本政策如何更新</li>
      <li>本政策的适用范围</li>
    </ul>

    <br/>

    <h5><strong>一、定义</strong></h5>
    <br/>
    <ol>
      <li><strong>个人信息：</strong>是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括网络身份识别信息（包括账号、头像、IP地址、邮箱地址、密码）、软件信息（包括软件版本号、序列号、激活码、渠道号、授权类型或其他用于连接金山词霸在线服务的软件相关数据）、设备信息（设备属性信息（例如您的设备型号、操作系统版本、设备配置、唯一设备标识符、设备地理位置、存储空间、国际移动设备身份码IMEI、网络设备硬件地址MAC、广告标识符IDFA等）、设备连接信息（浏览器的类型、电信运营商、网络环境、使用的语言）以及设备状态信息（例如设备传感器数据，设备应用安装列表））、文档信息、日志信息（包括您对金山词霸软件、金山词霸在线服务、相关网站的使用情况、IP地址、所访问服务的URL、浏览器的类型和使用的语言、下载、安装或使用移动应用和软件的信息、与通讯软件通讯的信息以及访问金山词霸在线服务、相关网站的日期、时间、时长等）等。
      </li>
      <li><strong>个人敏感信息：</strong>是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。本政策中涉及的个人敏感信息，将采用加粗字体突出显示。
      </li>
      <li>
        <strong>关联公司：</strong>均指不时（直接或间接）控制（或与其他方共同控制）该方，受该方控制（或受该方与其他第三方的共同控制），或与该方同受控制的公司，无论如何，（直接或间接）享有该公司50%以上的管理或决策权利（不论是通过表决权、合同或其他方式）均应视为控制。金山办公关联公司包括但不限于北京金山办公软件股份有限公司、珠海奇文办公软件有限公司、广州金山移动科技有限公司、武汉金山办公软件有限公司、安徽金山办公软件有限公司、北京金山软件有限公司、武汉市金山小额贷款有限责任公司。
      </li>
      <li>
        <strong>金山办公：</strong>是指北京金山办公软件股份有限公司或珠海金山办公软件有限公司，具体到本政策提及的每个金山办公是指北京金山办公软件股份有限公司还是珠海金山办公软件有限公司，将由金山办公结合您的具体情况判断确定。
      </li>
    </ol>

    <br/>

    <h5><strong>二、如何收集和使用您的个人信息</strong></h5>
    <br/>
    <h5>金山办公出于本政策所述的以下目的，收集和使用您的个人信息</h5>
    <br/>
    <h5><strong>（一）核心业务功能收集和使用您个人信息的情形：授权您使用金山词霸软件及/或向您提供金山词霸在线服务</strong></h5>
    <p>金山办公可能会收集、保存和使用下列与您有关的信息才能实现下述功能。如果您不提供相关信息，您将无法享受相关服务。这些功能包括：</p>
    <ol>
      <li>注册账号：如您需注册金山词霸在线服务账号，则为完成金山词霸在线服务账号创建，您需提供您的<strong>邮箱地址、手机号及密码；</strong></li>
      <li>授权第三方账号登录、使用金山词霸在线服务：可以登录、使用金山词霸在线服务的第三方账号包括微信账号、QQ账号、新浪微博账号、小米账号以及后续可能增加的其他账号，为使该等第三方账号登录、使用金山词霸在线服务，您需提供<strong>第三方账号/昵称、账号密码，</strong>上传您的第三方账号头像（如有）。前述第三方账号由金山办公之外的其他方提供，您在注册该等第三方账号时需要完全根据该账号提供方（例如您授权登录、使用金山词霸在线服务的账号系QQ账号，则该账号的提供方系腾讯，以此类推）的相关要求进行，第三方账号提供方对您的个人信息（包括个人敏感信息）的收集、使用、共享、转让等一切行为均适用于第三方账号提供方的隐私保护政策，您授权第三方账号登录、使用金山词霸在线服务则视为您已同意第三方账号提供方的隐私保护政策，同意第三方按照其隐私保护政策对您的个人信息（包括个人敏感信息）进行收集、使用、共享、转让等一切行为。</li>
      <li>向您提供金山词霸软件、金山词霸在线服务。通过收集序列号、激活码来验证金山词霸软件的授权类型、授权期限、授权范围等相关授权的合法性、有效性并提供金山词霸软件服务及相关技术支持。通过收集您的<strong>账号信息（账号、手机号、邮箱地址）、订单信息（如有）</strong>来核实您的金山词霸在线服务的合法性、有效性并提供金山词霸在线服务相关服务及相关技术支持。</li>
      <li>相关云服务的使用。金山办公目前所提供离线词典、付费词典、付费课程、生词本、单词云同步、每日一句跟读、单词跟读、语音翻译、长句翻译、图片翻译、内容收藏服务需要在云端实现的功能及后续推出依托于云的服务均以您在联网状态下、登录账号后将相关文档、图片、照片、语音等材料上传（包括手动上传和自动漫游）至云端为前提，金山办公收集您上传至云端的文档名称、内容、文档属性（包括但不限于文档类型、大小、页数等）、上传、启动云文档的频率、使用云文档的时长等信息是为您提供相关云服务所必需的。同时，您所上传的相关文档、图片、照片、语音等材料在脱敏后会作为AI 训练的基础材料读取、使用，以便为您提供相关的AI服务。</li>
      <li>帮助金山办公研发、设计新产品、新服务，改善、提升金山办公现有的产品及服务、优化用户体验：金山办公会通过您的软件信息、常用设备信息、日志信息、云服务使用情况（云文档的上传频率、使用时长、上传文档的名称、类型、属性等）进行数据分析，了解金山词霸软件、金山词霸在线服务的使用情况、适配情况，为新产品、新服务的研发、已有功能、服务的完善提供数据支撑。例如，金山办公会通过您的软件信息了解金山词霸软件、金山词霸在线服务的使用、适配情况，发现需要优化的功能、服务，提升用户体验；会通过分析您的日志信息，进一步挖掘金山词霸软件、金山词霸在线服务的新功能、新服务；有针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应。对于从您的各种设备上收集到的信息，金山办公可能会将它们进行关联，以便能在这些设备上为您提供一致的服务。金山办公可能会将来自某项服务的信息与来自其他服务的信息、合法间接获取的信息及合法公开渠道获取的信息结合，或者将合法获取的您的可识别个人信息与无法识别个人的信息结合，为您提供个性化服务及改善金山办公的产品和服务。</li>
      <li>提供相关AI服务。金山办公及其关联公司通过金山词霸软件、金山词霸在线服务提供图片识别、语音翻译AI服务，金山办公会在事先征得您同意的前提下（您对上传数据、资料的同意即为您同意金山办公收集您上传的数据、资料），收集、读取由您上传的数据、资料；同时，为了使该服务更加符合您的个人偏好、需求，金山办公会基于其所查阅、读取的内容依照金山的理解为您设置特征标签。但金山办公会采取安全措施和技术手段保护您的个人信息，并将通过技术手段对该等数据、资料进行去标识化处理，以降低其他组织或个人通过去标识化处理后的个人信息识别到您的风险。</li>
      <li>保证安全。为提高您使用金山词霸软件、金山词霸在线服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护账户安全，金山办公可能会通过了解您的浏览信息、<strong>订单信息</strong>、软件信息、设备信息等手段来判断您的账号风险，并可能会记录一些金山办公认为有风险的链接（“URL”）。金山办公也会收集您的设备信息、日志信息对于您在使用金山词霸软件、金山词霸在线服务时的问题进行分析、统计流量并排查可能存在的风险、在您选择向金山办公发送异常信息时予以排查。</li>
      <li>客服与售后。如您在使用金山词霸软件、金山词霸在线服务寻求服务支持时，金山办公会根据您的<strong>账号信息、订单信息</strong>核对您的身份及购买的相关产品或服务（如有），并根据您的软件信息、设备信息以及您发送的邮件内容、截图、文档或与金山办公客服人员的电话对话内容帮您查找原因、解决问题；金山办公可能会不时使用您的<strong>账号信息（如手机号、邮箱地址）</strong>来发送重要通知，例如有关兑换物的通知和相关协议条款、条件和政策变更；如果您通过金山词霸在线服务的相关网站页面、微信公众号等参与了抽奖、比赛或类似的促销，金山办公可能会要求您提供<strong>身份证号</strong>来核实您的真实身份；金山办公还会收集您参与问卷调查时向金山办公提交的问卷答复信息、您通过拨打客服热线、发送电子邮件、论坛发帖、公众号留言等各种方式提交咨询时所提供的联系人姓名、公司名称、<strong>联系电话、邮箱地址</strong>及您的咨询内容。</li>
      <li>支付结算：在您下单购买金山词霸会员服务、付费词典、付费课程时，您可以选择与金山办公合作的第三方支付机构（如支付宝、微信支付等支付通道，以下称“支付机构”）所提供的支付服务，金山办公需要将您的<strong>订单号、交易金额、交易内容</strong>的信息提供给支付机构以确认您的支付指令并完成支付。如您申请发票，还需提供以下信息：发票抬头、纳税人识别号、<strong>收票人邮箱地址</strong>，以及您根据您的开票需求提供的更多信息，如购买方信息。</li>
      <li>大数据分析。金山办公会将所收集的您的个人信息用于大数据分析</li>
      <li>遵从和执行适用的法律要求及相关的行业标准</li>
    </ol>
    <br/>
    <h5><strong>（二）间接获取、使用个人信息的情形</strong></h5>
    <ol>
      <li>当您使用金山办公关联公司服务时，或您的金山词霸在线服务账号与金山办公关联公司的服务账号绑定后，您同意金山办公根据实际业务及合作需要，如为了验证用户身份、向用户更精准的推送金山办公关联公司的营销信息，而从金山办公的关联公司处接收、使用、汇总、分析经您授权同意向金山办公提供的您的账号信息、设备信息、软件信息以及日志信息。</li>
      <li>金山办公可能从第三方账号提供方获取您授权共享的账户信息（头像、昵称），并在您同意本政策后将您的第三方账户与您的金山办公账号绑定，使您可以通过第三方账户直接登录并使用金山办公的服务。</li>
      <li>如您从金山办公的经销商、代理商渠道下单购买金山词霸软件、金山词霸在线服务，则金山办公将从该等第三方渠道获取您的订单信息，包括您的姓名、公司名称、电话号码、收货或联系地址、所购买的具体产品或服务内容信息。</li>
    </ol>
    <br/>
    <h5><strong>（三）其他用途</strong></h5>
    <ol>
      <li>金山办公会通过技术手段对收集的您的个人信息进行去标识化处理，去标识化处理的信息将无法识别主体，您知悉并同意，金山办公有权使用已经去标识化的信息。在不透露您个人信息的前提下，金山办公有权对用户数据库进行分析并予以商业化的利用。</li>
      <li>金山办公会用您的个人信息对金山词霸软件、金山词霸在线服务的使用进行总体性及匿名的数据统计及分析，所得数据可供金山办公及其认为有必要知悉该等信息的主体为实现本政策约定的目的使用。同时，金山办公可能会与公众共享这些统计信息，以展示金山词霸软件、金山词霸在线服务的整体使用趋势，但这些统计信息将不会包含您的任何身份识别信息。</li>
      <li>当金山办公展示您的个人信息时，会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。</li>
      <li>在金山办公认为有必要的前提下，将您的个人信息提交金山办公认可的第三方机构进行包括但不限于恶意刷单、恶意刷量等的风险检测评估。</li>
    </ol>
    <br/>
    <h5><strong>（四）征得同意的例外</strong></h5>
    <h5>您充分知悉，在以下情形中，金山办公收集、使用个人信息无须征得您的授权同意：</h5>
    <ol>
      <li>与国家安全、国防安全直接相关的</li>
      <li>与公共安全、公共卫生、重大公共利益直接相关的</li>
      <li>与刑事侦查、起诉、审判和判决执行等直接相关的；</li>
      <li>出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</li>
      <li>所涉及的个人信息是个人信息主体自行向社会公众公开的</li>
      <li>根据您的要求签订和履行合同所必需的；</li>
      <li>从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道</li>
      <li>维护所提供产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</li>
      <li>新闻单位开展合法的新闻报道所必需的；</li>
      <li>学术研究机构出于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</li>
    </ol>
    <h5>金山办公收集您的个人信息的内容、来源及方式会因您所使用的金山词霸软件的不同（包括不同收费方式的版本、不同语言版本、不同客户端等）或者金山词霸在线服务的不同而不同，如您想要了解更多信息，请发送邮件至KCB_KF@kingsoft.com，金山办公将对您的来信予以积极回应。</h5>

    <br/>

    <h5><strong>三、如何使用Cookie和同类技术</strong></h5>
    <br/>
    <h5>（一）Cookie:为确保网站正常运转，金山办公会在您的计算机或移动设备上存储名为Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站能够存储互联网协议 (IP) 地址、浏览器类型、互联网服务供应商 (ISP)、引用/退出页面、操作系统、日期/时间戳和/或点击流数据、您的偏好等数据。金山办公不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止Cookie 的功能，但如此，则您需要在每一次访问金山词霸在线服务相关网站时亲自更改用户设置日志文件。您可以通过更改您的浏览器设置限制金山办公对Cookie的使用。
    </h5>
    <h5>（二）网站信标和像素标签。除 Cookie 外，金山办公还会在网站上使用网站信标和像素标签等其他同类技术。例如，金山办公向您发送的电子邮件可能含有链接至金山词霸在线服务相关网站内容的点击 URL。如果您点击该链接，金山办公则会跟踪此次点击，帮助金山办公了解您对金山词霸软件、金山词霸在线服务偏好并改善。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，金山办公能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从金山办公的寄信名单中退订。</h5>
    <h5>（三）Do Not Track（请勿追踪）。很多网络浏览器均设有 Do Not Track 功能，该功能可向网站发布 Do Not Track 请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了 Do Not Track，那么金山办公的所有网站都会尊重您的选择。</h5>
    <h5>（四）移动分析软件：在金山词霸软件的移动客户端中，金山办公使用移动分析软件，以更好地了解金山词霸软件在您的手机中的功能。 此款软件可能记录以下信息，如您使用该应用程序的频率、该应用程序内发生的事件、累计使用、性能数据及应用程序崩溃发生的位置。金山办公不会将存储于分析软件内的信息链接到您在金山词霸软件移动客户端中提交的任何个人信息。</h5>

    <br/>

    <h5><strong>四、如何共享、转让、公开披露您的个人信息</strong></h5>
    <br/>
    <h5>（一）共享</h5>
    <p>金山办公不会与金山办公以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>
    <ol>
      <li>在获取明确同意的情况下共享：获得您的明确同意后，金山办公可能会与第三方共享您的个人信息。</li>
      <li>金山办公可能会按照法律法规的要求或强制性的政府要求或司法裁定等，与相关的第三方共享您的个人信息。</li>
      <li>与关联公司共享：为了提升金山办公向您所推送的关联公司的产品、服务，您的个人信息可能会与金山办公有合作关系的关联公司共享，用于其产品、服务的身份验证、客户服务、安全防范、诈骗监测、信贷分析等，珠海金山办公软件有限公司会将收集到的您的个人信息共享给北京金山办公软件股份有限公司数据团队进行大数据分析。金山办公只会共享必要的个人信息，关联公司如果要改变个人信息的处理目的，将再次征求您的授权同意。</li>
      <li>与授权合作伙伴共享： 仅为实现本政策中声明的若干目的，金山办公的某些服务将由第三方合作伙伴提供。金山办公可能会第三方与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。金山办公仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享与提供服务所必要的个人信息。金山办公的第三方合作伙伴无权将共享的个人信息用于任何其他用途。您同意金山办公与如下第三方共享个人信息：
        <ol>
          <li>广告、分析服务类的合作伙伴。除非得到您的许可，否则金山办公不会将您的个人身份信息与提供广告、分析服务的合作伙伴分享。金山办公会向这些合作伙伴提供有关其广告覆盖面和有效性的信息，而不会提供您的个人身份信息，或者金山办公将这些信息进行汇总，以便它不会识别您个人。例如，金山办公可能会告诉广告主他们广告的效果如何，或者有多少人看了他们广告或在看到广告后安装了应用，或者向这些合作伙伴提供不能识别个人身份的人口统计信息（例如“位于北京的25岁男性，喜欢软件开发”）， 帮助他们了解其受众或顾客。金山办公会向这些合作伙伴提供您的设备识别码，帮助他们了解您是否为其受众或顾客。</li>
          <li>供应商、服务提供商和其他合作伙伴。金山办公将信息发送给在全球范围内支持金山办公业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、软硬件产品服务、系统产品服务、分析服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查以及为需要通过金山词霸在线服务账号登录、使用金山词霸软件、金山词霸在线服务中接入的第三方产品、服务共享您的账号、头像、昵称、性别。对金山办公与之共享您个人信息的公司、组织和个人，金山办公会要求他们按照金山办公的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</li>
          <li>
            如您通过金山词霸在线服务的相关网站页面、微信公众号等参与了抽奖、比赛或类似的促销或者使用积分兑换商品，金山办公或者相关奖品、商品的供货商需要向您寄送相关奖品、商品时，您作为收件人，您的信息（<strong>姓名、电话号码（包括手机号）、联系地址</strong>）将被提供给快递服务合作伙伴顺丰、圆通（具体以网页上显示的为准）或者相关供货商。
          </li>
        </ol>
      </li>
    </ol>
    <br/>
    <h5>（二）转让</h5>
    <p>金山办公不会将您的个人信息转让给关联公司外的任何公司、组织和个人，但以下情形除外：</p>
    <ol>
      <li>事先获得您的明确授权或同意；</li>
      <li>满足法律法规、法律程序的要求或强制性的政府要求或司法裁定；</li>
      <li>如果金山办公或金山办公的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，金山办公将确保该等信息在转移时的机密性，并要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则金山办公将要求该公司、组织重新向您征求授权同意。</li>
    </ol>
    <br/>
    <h5>（三）公开披露</h5>
    <p>金山办公仅会在以下情形下，公开披露您的个人信息</p>
    <ol>
      <li>获得您的明确同意</li>
      <li>在公布中奖活动名单时会脱敏展示中奖者手机号或账户登录名；</li>
      <li>金山办公可能对外公开并与有合作关系的第三方分享经统计加工后不含身份识别内容的大数据分析信息。</li>
      <li>如果金山办公接到第三方对您的投诉或举报，金山公司有权向投诉方披露您的必要信息（包括但不限于注册名称、身份证明、联系人、联系电话等），并督促您与投诉方进行协商，以便及时解决投诉、纠纷，保护各方合法权益。</li>
      <li>基于法律法规、法律程序、诉讼或政府主管部门强制性要求下。</li>

    </ol>
    <br/>
    <p>您知悉并认可，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
    <br/>
    <h5>（四）金山词霸软件移动客户端涉及嵌入第三方代码、插件传输个人信息的情形逐项举例</h5>
    <br/>
    <table>
      <thead>
        <tr>
          <th>第三方<br/>机构名称</th>
          <th>收集目的</th>
          <th>收集方式</th>
          <th>收集范围</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>七牛</td>
          <td>视频播放</td>
          <td>第三方收集</td>
          <td>个人常用设备信息</td>
        </tr>
        <tr>
          <td>腾讯</td>
          <td>微信账号登录</td>
          <td>第三方收集</td>
          <td>个人常用设备信息</td>
        </tr>
        <tr>
          <td></td>
          <td>内核浏览器</td>
          <td></td>
          <td>个人常用设备信息</td>
        </tr>
        <tr>
          <td></td>
          <td>微信分享、<br/>支付、收藏</td>
          <td></td>
          <td>个人常用设备信息</td>
        </tr>
        <tr>
          <td>新浪</td>
          <td>微博账号登录</td>
          <td>第三方收集</td>
          <td>个人常用设备信息</td>
        </tr>
        <tr>
          <td>小米</td>
          <td>小米账号登录</td>
          <td>第三方收集</td>
          <td>个人常用设备信息</td>
        </tr>
        <tr>
          <td>科大讯飞</td>
          <td>语音翻译识别</td>
          <td>第三方收集</td>
          <td>个人常用设备信息</td>
        </tr>
        <tr>
          <td>一答</td>
          <td>图片识别</td>
          <td>第三方收集</td>
          <td>手机图片</td>
        </tr>
        <tr>
          <td>广点通</td>
          <td>推送服务</td>
          <td>第三方收集</td>
          <td>个人常用设备信息</td>
        </tr>
        <tr>
          <td>个推</td>
          <td>推送服务</td>
          <td>第三方收集</td>
          <td>个人常用设备信息，<br/>常用手机信息</td>
        </tr>
        <tr>
          <td>百度</td>
          <td>推送服务</td>
          <td>第三方收集</td>
          <td>个人常用设备信息</td>
        </tr>
        <tr>
          <td>友盟</td>
          <td>数据统计</td>
          <td>第三方收集</td>
          <td>个人常用设备信息，<br/>埋点事件名</td>
        </tr>
      </tbody>
    </table>

    <br/>

    <h5><strong>五、如何保护和保存您的个人信息</strong></h5>
    <br/>
    <h5>（一）金山办公将努力使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。金山办公会采取一切合理可行的措施，确保未收集无关的个人信息。金山办公只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
    </h5>
    <h5>（二）由于互联网并非绝对安全的环境，且电子邮件、及时通讯及与其他第三方的线上交流方式可能并未加密，金山办公强烈建议您不要通过此类方式发送个人信息。同时，在注册使用金山词霸在线服务账户时，请注意使用复杂密码，协助金山办公保证您的账号安全。</h5>
    <h5>（三）金山办公经金山词霸软件、金山词霸在线服务收集的您的个人信息可能会在金山办公及其关联公司所在地进行存储和处理，也有可能会在金山办公认为有必要知悉该等信息的主体处进行保存和处理。金山办公仅在本政策所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。金山办公会严格遵守中国大陆关于收集、使用、保存、共享用户个人信息的相关法律法规，使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。</h5>

    <br/>

    <h5><strong>六、查询、更正信息、撤回同意及删除账号的方式</strong></h5>
    <br/>
    <h5>（一）如果您需要查询、修改或更正您的个人信息，或对您的个人信息保护问题有任何疑问或投诉举报建议，您可以通过发送邮件至金山办公电子邮箱KCB_KF@kingsoft.com，金山办公将及时有效地处理您的问题。
    </h5>
    <h5>（二）您可以通过提交请求撤销之前出于特定目的授予金山办公的同意，包括收集、使用和/或披露金山办公掌握或控制的您的个人信息。根据您所使用的金山词霸软件或金山词霸在线服务，您可以发送邮件到KCB_KF@kingsoft.com，金山办公将会在您作出请求后的十五个工作日内处理您的请求，并且会根据您的请求，此后不再收集、使用和/或披露您的个人信息。取决于您撤销同意的范围，其可能导致您不能继续使用金山词霸软件和金山词霸在线服务。但您撤回同意或授权的决定，不会影响金山办公此前基于您的同意而开展的个人信息处理活动的有效性。</h5>
    <h5>（三）如果您需删除您的金山词霸账号或将您授权的登录、使用金山词霸在线服务的第三方账号与金山词霸账户解除绑定，您可通过金山词霸软件移动客户端中的“我的”-“账号安全”-“永久删除账号”入口删除金山词霸在线服务账号。<strong>请您知悉，删除金山词霸在线服务账号或将第三方账号解除绑定后，您账户内的所有文档、账号信息等都将被清空，且无法恢复。</strong></h5>

    <br/>

    <h5><strong>七、未成年人信息的保护</strong></h5>
    <br/>
    <ol>
      <li>若你是14周岁以下的儿童，金山办公还专门为你及你的监护人制定了<a href="https://www.wps.cn/privacy/kids">《金山办公儿童信息保护声明》</a>，在完成金山词霸软件的安装或金山词霸在线服务账号的注册、绑定前，你及你的监护人还应仔细阅读<a href="https://www.wps.cn/privacy/kids">《金山办公儿童信息保护声明》</a>，只有在取得监护人对<a href="https://www.wps.cn/privacy/kids">《金山办公儿童信息保护声明》</a>的同意后，你可使用金山词霸软件或金山词霸在线服务。</li>
      <li>若您是14周岁以上的未成年人，金山办公建议您不要向金山办公发送您的个人信息。您在使用金山词霸软件、金山词霸在线服务前，应事先取得您的家长或监护人的同意，建议您的家长或监护人仔细阅读本政策，建议您在您的家长或监护人的指导下使用金山词霸软件、金山词霸在线服务。一旦您以任何方式下载、安装、使用金山词霸软件、登录、注册、使用金山词霸在线服务的任何部分或全部，即表明您的家长或监护人同意您使用金山词霸软件、金山词霸在线服务并同意本政策的全部内容，同时允许金山办公依据本政策收集、使用、保存、共享您的个人信息。如果家长或监护人有理由相信未成年人未经他们事先同意而向金山办公提交了未成年人的个人信息，请联系金山办公以确保删除此类个人信息。</li>
    </ol>

    <br/>

    <h5><strong>八、您的个人信息如何在全球范围转移</strong></h5>
    <br/>
    <p>原则上，金山办公将在中华人民共和国境内收集和产生的个人信息存储于中华人民共和国境内。您理解并同意，由于金山办公通过遍布全球的资源和服务器提供产品或服务，这意味着，金山办公在遵守适用的个人信息跨境传输法律法规的前提下，可能根据公司运营的实际需求将根据本政策搜集的信息存储于中国大陆以外的其他国家/地区的服务器上、可能将您的个人信息的部分/全部提供给金山办公境外的关联公司、与金山办公及/或金山办公关联公司有合作关系的中国大陆以外的第三方。此类国家/地区可能设有不同的数据保护法，甚至未设立相关数据保护法律，如果您不同意信息出境或者您想要了解更多信息，请发送邮件至KCB_KF@kingsoft.com，金山办公将根据您的来信妥善处理，金山办公提供的金山词霸软件和在线服务可能会因为您不同意信息出境而无法使用。</p>

    <br/>

    <h5><strong>九、本政策如何更新</strong></h5>
    <br/>
    <ol>
      <li>为给您提供更好的服务以及随着金山办公业务的发展，本政策之规定可能会不定期地修改，但未经您明确同意，金山办公不会削减您依据本政策所应享有的权利。金山办公会通过网址为【https://cdn.iciba.com/www/terms/iciba/mobile/privacy.html】的网站、金山词霸软件客户端发出更新版本。金山办公在此建议您登录网址为【https://cdn.iciba.com/www/terms/iciba/mobile/privacy.html】的网页定期查阅本政策，以随时了解本政策是否发生修改以及修改后的内容。</li>
      <li>金山办公会将本隐私政策的旧版本存档，供您查阅。</li>
    </ol>

    <br/>

    <h5><strong>十、本政策的适用范围</strong></h5>
    <br/>
    <ol>
      <li>本政策适用于全部版本的金山词霸软件及金山词霸在线服务所包括的全部子服务。如某一版本金山词霸软件或某一特定的子服务对收集信息事项有特殊的规定，需同时适用该特殊规定及本政策；若该特殊规定与本政策有不一致之处，则适用该特殊规定。</li>
      <li><strong>请您注意，本政策不适用于第三方提供的产品和服务。金山词霸软件、金山词霸在线服务可能包括第三方的产品和服务，以及第三方网站的链接。当您使用这些产品或服务时，也可能收集您的信息。因此，强烈建议您花时间阅读该第三方的隐私政策，就像阅读本政策一样。金山办公不对第三方如何使用他们向您收集的个人信息负责，也不能控制其使用。本政策不适用通过金山词霸软件、金山词霸在线服务链接的其他网站。</strong></li>
    </ol>

    <br/>

    <h5><strong>十一、特别提示</strong></h5>
    <br/>
    <p>本政策所述的金山办公认为有必要知悉该等信息的主体包括金山办公的员工及其他金山办公认为有必要知悉该等信息的个人、机构或组织，您知悉并同意金山办公通过金山词霸软件、金山词霸在线服务收集您的个人信息，金山办公可以向其认为有必要知悉该等信息的主体披露，但是金山办公保证其认为有必要知悉该等信息的主体都只能在为实现本政策约定的目的使用该等信息。</p>
    <p>本政策各条款的标题仅为方便用户阅读列出，各条款表达的具体信息仍以各条款载明的实际内容为准。</p>
    <p><strong>金山办公认为，且您亦同意，您在使用金山词霸软件、金山词霸在线服务前已经仔细阅读并完全理解本政策的全部内容，一旦您使用金山词霸软件、金山词霸在线服务，则表明您同意本政策的全部内容且承诺受本政策之约束。</strong></p>
    </div>
  )


}